import { CategoryToursDashboardTypes } from 'dashboard/_redux/types/categoryToursDashboardTypes';
import { emptyPaginationPayload } from 'server/constants/emptyPaginationPayload';
import { ICategoryTour } from 'client/models/ICategoryTour';
import { IReduxAction } from 'types/IReduxAction';
import { PaginatedResponse } from 'types/Posts';

export interface ICategoryToursDashboardState {
  loading: boolean;
  loaded: boolean;
  categoryTours: PaginatedResponse<ICategoryTour>;
  selectedCategoryTour?: ICategoryTour;
}

const initialState: ICategoryToursDashboardState = {
  loading: false,
  loaded: false,
  categoryTours: emptyPaginationPayload,
};

export default (
  state = initialState,
  { type, payload }: IReduxAction,
): ICategoryToursDashboardState => {
  switch (type) {
    case CategoryToursDashboardTypes.FETCH_CATEGORY_TOURS_SUCCESS:
      return { ...state, loaded: true, categoryTours: payload };
    case CategoryToursDashboardTypes.UPDATE_CATEGORY_TOUR_SUCCESS:
      return { ...state, loaded: true, selectedCategoryTour: payload };

    default:
      return state;
  }
};
